import { ApiProperty } from '@nestjs/swagger';
import { IsUUID } from 'class-validator';

export class RemoveChapterFromPathDto {
  @ApiProperty({ description: 'ID du chapitre à retirer du parcours' })
  @IsUUID()
  chapterId!: string;
}

